export default {"src":"/_next/static/media/specialDayBackground.1c9b66a8.svg","height":83,"width":320,"blurWidth":0,"blurHeight":0};